const base = `${process.env.baseUrl}/api/wizardcv/`
export const API = {
  data: `${process.env.baseUrl}/api/wizardcv/data`,
  firststepLoggedIn: `${base}firststep/true`,
  firststepLoggedOut: `${base}firststep/false`,
  secondstep: `${base}secondstep`,
  thirdstep: `${base}thirdstep`,
  forthstep: `${base}forthstep`,
  fifthstep: `${base}fifthstep`
}

export const EmptyData = {
  firststep: null,
  secondstep: {
    HideBirthYear: false,
    HomePhone: '',
    Citizenship: '',
    IdNumber: '',
    FamilyStatus: '',
    Children: '',
    IsNew: false,
    CvCode: '',
    Save: false
  },
  thirdstep: {
    EducationData: [
      {
        '<Subject>k__BackingField': 'string',
        '<Diploma>k__BackingField': 'string',
        '<School>k__BackingField': 'string',
        '<FromYear>k__BackingField': 0,
        '<ToYear>k__BackingField': 0,
        '<Description>k__BackingField': 'string'
      }
    ],
    Save: false
  },
  forthstep: {
    WorkExperience: [
      {
        '<Title>k__BackingField': 'string',
        '<Company>k__BackingField': 'string',
        '<FromYear>k__BackingField': 0,
        '<ToYear>k__BackingField': 0,
        '<Description>k__BackingField': 'string'
      }
    ],
    Save: false
  },
  fifthstep: {
    MilitaryExperienceAndAditionalData: {
      '<Service>k__BackingField': [
        {
          '<ArmyService>k__BackingField': true,
          '<Position>k__BackingField': 'string',
          '<FromYear>k__BackingField': 0,
          '<ToYear>k__BackingField': 0,
          '<Description>k__BackingField': 'string'
        }
      ],
      '<Languages>k__BackingField': [
        {
          '<Language>k__BackingField': 'string',
          '<Level>k__BackingField': 1
        }
      ],
      '<License>k__BackingField': true,
      '<Discrete>k__BackingField': true,
      '<Move>k__BackingField': true,
      '<Relocation>k__BackingField': true,
      '<MomJob>k__BackingField': true,
      '<Partial>k__BackingField': true,
      '<References>k__BackingField': true
    },
    Save: false
  }
}
